import { render, staticRenderFns } from "./GlobalStyle.vue?vue&type=template&id=464f4c51&"
import script from "./GlobalStyle.vue?vue&type=script&lang=js&"
export * from "./GlobalStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports